var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import filterXss from 'xss';
import { toDateInputValue } from '../app/date-helpers';
import { APIService } from '../services/api';
import LogService from './log';
export function createReservation(reservationData) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, data, urlParams, queryPart, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = '/reservations';
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, APIService.post(url, reservationData)];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _a.sent();
                    if (response.status === 422) {
                        LogService.error('createReservation 422', { response: data }, { instant: true });
                        return [2 /*return*/, {
                                success: false,
                                error: {
                                    type: 'validation',
                                    message: data.message || 'Walidacja nie powiodła się',
                                    errors: data.errors || {},
                                    data: data
                                }
                            }];
                    }
                    if (!response.ok) {
                        LogService.error('createReservation error', { status: response.status, data: data }, { instant: true });
                        return [2 /*return*/, {
                                success: false,
                                error: {
                                    type: 'generic',
                                    message: data.message || 'Wystąpił błąd podczas tworzenia rezerwacji',
                                    data: data
                                }
                            }];
                    }
                    if (data.code) {
                        urlParams = new URLSearchParams(filterXss(window.location.search));
                        queryPart = urlParams.get('showHeader') === 'false' ? '?showHeader=false' : '';
                        window.location.href = "/thank-you/".concat(data.code).concat(queryPart);
                        return [2 /*return*/, { success: true }];
                    }
                    else {
                        LogService.error('createReservation no code', data, { instant: true });
                        return [2 /*return*/, {
                                success: false,
                                error: {
                                    type: 'generic',
                                    message: 'Rezerwacja została utworzona, ale nie otrzymano kodu potwierdzenia',
                                    data: data
                                }
                            }];
                    }
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    LogService.fetchError({ url: url, e: e_1, actionName: 'createReservation' });
                    return [2 /*return*/, {
                            success: false,
                            error: {
                                type: 'generic',
                                message: 'Wystąpił błąd sieciowy podczas tworzenia rezerwacji'
                            }
                        }];
                case 5: return [2 /*return*/];
            }
        });
    });
}
export function mapReservationFormValuesToDTO(values) {
    var area_preferences = values.area_preferences, customer_fn = values.customer_fn, customer_ln = values.customer_ln, customer_phone = values.customer_phone, customer_email = values.customer_email, duration = values.duration, non_vaccinated_amount = values.non_vaccinated_amount, kids_number = values.kids_number, notes_from_guest = values.notes_from_guest, source = values.source, sms_marketing = values.sms_marketing, email_marketing = values.email_marketing;
    var phone = customer_phone.trim().split(' ').join('');
    var extras = __assign(__assign(__assign({}, (kids_number ? { kids_number: kids_number } : {})), (area_preferences ? { area_preferences: area_preferences } : {})), (non_vaccinated_amount ? { non_vaccinated_amount: non_vaccinated_amount } : {}));
    return __assign(__assign({ customer_name: "".concat(customer_fn, " ").concat(customer_ln), phone_number: phone, email: customer_email, restaurant_id: values.restaurantId, reserved_on: toDateInputValue(values.visitDate) + ' ' + values.visitTime + ':00' }, (!!duration ? { duration: duration } : {})), { guests_number: values.peopleAmount, notes_from_guest: notes_from_guest, source: source, extras: extras, sms_marketing: sms_marketing, email_marketing: email_marketing });
}
export function getHoursRange(start, end, step, format) {
    if (start === void 0) { start = 32400; }
    if (end === void 0) { end = 86400; }
    if (step === void 0) { step = 1800; }
    if (format === void 0) { format = 'H:i'; }
    // Convert a timestamp to the 'H:i' format
    var formatTime = function (timestamp) {
        return new Date(timestamp * 1000).toISOString().substr(11, 5);
    };
    // Generate a list of timestamps between start and end
    var generateTimestamps = function (start, end, step) {
        var timestamps = [];
        for (var current = start; current <= end; current += step) {
            timestamps.push(current);
        }
        return timestamps;
    };
    // Convert the list of timestamps to a time range
    var timestamps = generateTimestamps(start, end, step);
    var times = timestamps.map(function (timestamp) {
        return format
            ? formatTime(timestamp)
            : new Date(timestamp * 1000).toISOString().substr(11, 5);
    });
    return times;
}
